import * as React from "react"
import {CSSProperties} from "react";

export interface Props extends React.Props<Button> {
	className?:string
	disabled?:boolean
	onClick?:() => void
	type?: Type
	icon?: string
	emoji?: string
}

export const enum Type {
	button,
	submit,
	reset
}

const buttonTypeToString = (type: Type): "button"|"submit"|"reset" => {
	switch (type) {
		case Type.button:
			return "button"
		case Type.submit:
			return "submit"
		case Type.reset:
			return "reset"
	}
}

export class Button extends React.Component<Props, {}> {
	render() {
		let className = this.props.disabled ? "sbButtonOff" : "sbButton"

		if (this.props.className) {
			className += ' ' + this.props.className
		}

		const type = buttonTypeToString(this.props.type || Type.button)

		const icon = this.props.icon && <img style={{paddingRight: "1ex",verticalAlign: "bottom"}} src={this.props.icon} />
		const style: CSSProperties | undefined = this.props.emoji ?  {position: "relative", filter: this.props.disabled && "grayscale(100%)" } : undefined
		const children = this.props.emoji ? <span style={{marginLeft: "2em"}}>{this.props.children}</span> : this.props.children
		const emoji = this.props.emoji && <span style={{position: "absolute", fontSize: "150%"}}>{this.props.emoji}</span>

		return <button
			type={type}
			onClick={(event:React.FormEvent<{}>) => {
				event.stopPropagation()
				if (this.props.onClick) {
					this.props.onClick()
				}
			}}
			disabled={this.props.disabled}
			className={className}
			style={style}
		>{icon}{emoji}{children}</button>
	}
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/button.tsx